import { gql } from '@apollo/client'

export const SelectedQuery = gql`
  query SelectedVenueSelector($companyId: ID!, $id: ID) {
    venues(companyId: $companyId, filters: { idEq: $id }) {
      nodes {
        id
        name
        address
      }
    }
  }
`

export const Query = gql`
  query VenueSelector(
    $companyId: ID!,
    $filters: VenueFilters,
    $after: String,
    $before: String,
    $first: Int,
    $last: Int
  ) {
    venues(companyId: $companyId, filters: $filters, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        name
        address
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
